function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_12961",
  "data-name": "Group 12961",
  transform: "translate(-0.612 -3.019)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_14016",
  "data-name": "Path 14016",
  d: "M30.116,9.448l5.7-2.319c.016-.087.029-.176.036-.265.562-5.129-7.365-5.129-6.8,0A7.323,7.323,0,0,0,30.116,9.448Z",
  transform: "translate(-23.901)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_14017",
  "data-name": "Path 14017",
  d: "M15.738,54.5l-.146-.971a2.065,2.065,0,0,1-.018-.313L8.415,56.132c-.91.48-1.656,1.1-1.661,1.986h0c0,1.776,13.2,2.143,13.917.009C20.669,55.9,15.894,55.318,15.738,54.5Z",
  transform: "translate(-5.166 -42.24)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_14018",
  "data-name": "Path 14018",
  d: "M15.687,24.654.612,30.79,1.3,32.037,16.371,25.9Z",
  transform: "translate(0 -18.205)"
}));
const SvgDeletedUser = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15.759,
    height: 14.334,
    viewBox: "0 0 15.759 14.334",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDeletedUser, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/DeletedUser.d891af78.svg";
export { ForwardRef as ReactComponent };